import {
    getCalendarLogo,
    getCalendarName,
} from '../../commons/utils/utils';

// the value is the calendar type that will be sent to the backend in the complete-subscription request
const calendars = [
    {
        name: getCalendarName('google'),
        value: 'google',
        logo: getCalendarLogo('google'),
    },
    {
        name: getCalendarName('android'),
        value: 'android',
        logo: getCalendarLogo('android'),
    },
    {
        name: getCalendarName('apple'),
        value: 'apple',
        logo: getCalendarLogo('apple'),
    },
    {
        name: getCalendarName('windowslive'),
        value: 'windowslive',
        logo: getCalendarLogo('windowslive'),
    },
    {
        name: getCalendarName('outlook'),
        value: 'outlook',
        logo: getCalendarLogo('outlook'),
    },

    {
        name: getCalendarName('outlook-new'),
        value: 'outlook-new',
        logo: getCalendarLogo('outlook-new'),
    },

    {
        name: getCalendarName('office365'),
        value: 'office365',
        logo: getCalendarLogo('office365'),
    },
    {
        name: getCalendarName('ics_other'),
        value: 'ics_other',
        logo: getCalendarLogo('ics_other'),
    },
];

export function calendarsForMacAndIPad () {
    return calendars.filter((calendar) => {
        return (calendar.value !== 'android' &&
            calendar.value !== 'outlook-new' &&
            calendar.value !== 'outlook');
    });
}

export function calendarsForNonMac () {
    return calendars.filter((calendar) => {
        if (calendar.value === 'apple') {
            return false;
        } 
        else if (calendar.value !== 'android') {
            return true;
        }  
        return false;
    });
}

export function calendarsForIOS () {
    
    return calendars.filter((calendar) => {
        if (calendar.value === 'google') {
            return true;
        } else if (calendar.value === 'apple') {
            return true;
        } else if (calendar.value === 'windowslive') {
            return true;
        } else if (calendar.value === 'office365') {
            return true;
        }

        return false;
    });
}

export function calendarsForAndroid () {
    return calendars.filter((calendar) => {
        if (calendar.value === 'google') {
            return true;
        } else if (calendar.value === 'android') {
            return true;
        } else if (calendar.value === 'windowslive') {
            return true;
        } else if (calendar.value === 'office365') {
            return true;
        }
        return false;
    });
}

export default calendars;